import useActions from '../../../hooks/useActions';
import { getIndexOnSaleActions } from '../../../redux/actions/getOnSaleActions';
import { makeIsReloadAboutWholeHome } from '../../../redux/selectors/homepageSelector';
import {
  makeDataByKey,
  makeRandomItems,
} from '../../../redux/selectors/onSale';
import { useSelector } from '../../../redux/utils';

export const useReduxHooks = productsAmount => {
  const isFetching = useSelector(makeDataByKey('indexIsFetching'));
  const loadingType = useSelector(makeDataByKey('indexLoadingType'));
  const products = useSelector(makeRandomItems(productsAmount));
  const isHomePageReload = useSelector(makeIsReloadAboutWholeHome());
  const getIndexOnSale = useActions(getIndexOnSaleActions.request);

  return {
    isFetching,
    loadingType,
    products,
    isHomePageReload,
    getIndexOnSale,
  };
};
